var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"20px 0 -20px"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('div',[_c('p',{staticClass:"font-weight-bold text-center text--accent-2 ml-5"},[_c('v-icon',{staticClass:"mr-4",staticStyle:{"flex":"0"},domProps:{"textContent":_vm._s(_vm.icon)}}),_vm._v(" "+_vm._s(_vm.title.toUpperCase())+" ")],1)])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }